import { TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react";
import { Tab } from "@/components/ui/tab";

import { ClinicianUpdate } from "@/features/clinician/manage/components/clinician-update";
import { PracticeUpdate } from "@/features/clinician/manage/components/practice-update";

const Manage = () => {
    return (
        <TabGroup className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">Your profile</h1>
                <TabList className="mx-auto flex pt-1.5 pb-2">
                    <Tab>Personal</Tab>
                    <Tab>Practice</Tab>
                </TabList>
            </div>
            <TabPanels className="container mx-auto mt-4">
                <TabPanel unmount={false}>
                    <ClinicianUpdate />
                </TabPanel>
                <TabPanel unmount={false}>
                    <PracticeUpdate />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
};

export default Manage;
